import { useEffect, useState, useRef } from "react";
import "./componentsCss/ListCard.css";
import api from "../api";
import Loading from "./Loading";
import { Spinner } from "react-bootstrap";
import "./../components/componentsCss/ListCard.css";
import Swal from "sweetalert2";
import moment from "moment";
import CardSchedulingsPayment from "./cards/CardSchedulingsPayment";
import axios from "axios";

function ListCardProfessionalsReportPayments({
  initialDate,
  finalDate,
  professional,
  shopper,
}) {
  const [schedulings, setSchedulings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filePayment, setFilePayment] = useState(null);
  const [schedulingToPay, setSchedulingToPay] = useState([]);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [errors, setErrors] = useState({
    schedulingToPay: false,
    filePayment: false,
  });

  const cancelTokenSource = useRef(null);

  const totalPaymentValue = schedulingToPay.reduce((total, elem) => {
    return total + Number(elem.final_payment_value);
  }, 0);

  const payDoctors = async () => {
    if (loadingPayment === true) return;
    const obj_errors = {
      schedulingToPay: schedulingToPay.length === 0,
      filePayment: filePayment === null,
    };
    setErrors(obj_errors);

    if (!obj_errors.schedulingToPay && !obj_errors.filePayment) {
      setLoadingPayment(true);
      const formData = new FormData();
      formData.append("receipt_path", "receipts");
      formData.append("receipt", filePayment);
      formData.append("ref_month", moment().format("YYYY/MM"));
      formData.append("payment_date", moment().format("YYYY-MM-DD 00:00:00"));
      formData.append("payment_value", totalPaymentValue);
      formData.append("attendances", JSON.stringify(schedulingToPay));
      formData.append("shopper_id", shopper.value);

      try {
        const response = await api.post("/api/receipt/doctors/save", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        getSchedulings();
        setSchedulingToPay([]);
        setFilePayment(null);
        Swal.fire({
          title: "Pagamento Registrado",
          icon: "success",
          confirmButtonColor: "#3c8dbc",
        });
      } catch (error) {
        Swal.fire({
          title: "Erro ao registrar pagamento",
          text: error.message,
          icon: "error",
          confirmButtonColor: "#3c8dbc",
        });
      }

      setLoadingPayment(false);
    }
  };

  const getSchedulings = () => {
    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel("Requisição cancelada.");
    }

    cancelTokenSource.current = axios.CancelToken.source();

    const obj = {
      professional_id: professional ? professional.value : null,
      begin_date: initialDate,
      end_date: finalDate,
      shopper_id: shopper.value,
    };
    setLoading(true);

    api
      .post("/api/report/doctors/attendances/info", obj, {
        cancelToken: cancelTokenSource.current.token,
      })
      .then((response) => {
        const list_schedulings = response.data.map((elem) => {
          elem.id = elem.scheduling_id;
          return elem;
        });
        setSchedulings(list_schedulings);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log("Requisição cancelada:", error.message);
        } else {
          console.error("Erro ao buscar agendamentos:", error);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log("SchedulingTOPay:", schedulingToPay);
  }, [schedulingToPay]);

  useEffect(() => {
    setLoading(true);
    setSchedulings([]);
    setSchedulingToPay([]);
    if (shopper != null) {
      getSchedulings();
    }

    return () => {
      if (cancelTokenSource.current) {
        cancelTokenSource.current.cancel("Componente desmontado.");
      }
    };
  }, [initialDate, finalDate, professional, shopper]);

  return (
    <>
      {loading ? (
        <Loading color="black" />
      ) : (
        <>
          {schedulings.length > 0 ? (
            schedulings.map((elem, index) => (
              <CardSchedulingsPayment
                key={index}
                index={index}
                elem={elem}
                setSchedulingToPay={setSchedulingToPay}
              />
            ))
          ) : (
            <div>
              <h6
                style={{
                  textAlign: "center",
                  marginTop: "26px",
                  color: "black",
                }}>
                Sem Agendamentos
              </h6>
            </div>
          )}
        </>
      )}
      <div
        style={{
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
          background: "white",
          position: "absolute",
          bottom: 56,
          left: 0,
          padding: "12px 5px",
        }}
        className="buttons buttonsPayment">
        <div>
          <span
            style={{ color: errors.schedulingToPay ? "#ff6060" : "black" }}
            className="text-value text-value-sm">
            Valor Total:{" "}
          </span>
          <span
            className="text-value text-value-sm"
            style={{ color: errors.schedulingToPay ? "#ff6060" : "black" }}>
            {totalPaymentValue.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </span>
        </div>
        <div style={{ display: "flex", gap: 1, flexDirection: "column" }}>
          <label htmlFor="files" className="form-label-input">
            Comprovante de Pagamento
          </label>
          <input
            id="files"
            style={{ color: errors.filePayment ? "#ff6060" : "black" }}
            accept="application/pdf"
            type="file"
            onChange={(e) => setFilePayment(e.target.files[0])}
          />
        </div>
        <button
          style={{ cursor: "pointer" }}
          className="buttonModal buttonModal-sm"
          onClick={payDoctors}>
          Pagar
          {loadingPayment && (
            <Spinner
              style={{ color: "white", marginLeft: 10 }}
              size="sm"
              animation="border"
              role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </button>
      </div>
    </>
  );
}

export default ListCardProfessionalsReportPayments;
